:root {
  --White-Gradient: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.5) 60%,
    #ffffff 100%
  );
  --Grey-Gradient: linear-gradient(
    180deg,
    rgba(237, 241, 244, 0) 0%,
    rgba(237, 241, 244, 0.5) 60%,
    #edf1f4 100%
  );
  --Blue-Gradient: linear-gradient(
    180deg,
    rgba(0, 43, 73, 0) 0%,
    rgba(0, 43, 73, 0.5) 60%,
    #002b49 100%
  );
}

:host {
  /* Component styles go here */
}

button {
  display: grid;
  place-items: center;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  border: none;
  height: 100%;
  width: 100%;
  background-color: #ed0007;
  padding: 0;
}
button:hover {
  background-color: #d50005;
}
button:focus-visible {
  outline: 2px solid #000000;
  outline-offset: -12px;
}
@media (min-width: 768px) {
  button:focus-visible {
    outline-offset: -24px;
  }
}
button dc-ui-icon {
  color: #ffffff;
}